
import { Component, Vue, Prop } from 'vue-property-decorator';
import api from '@/api';
import Util from '@/utils/util';
import Swal from 'sweetalert2';

const { exchanger } = api;

@Component({
  components: { },
})
export default class ExchangerCurrencyForm extends Vue {
  @Prop({ }) exchangerId!: string;

  @Prop({ default: '' }) currencyId!: string;

  private loading: boolean = false;

  private valid: boolean = false;

  private currencyOption = [];

  private form = {
    exchangerId: this.exchangerId,
    currencyId: '',
    costExchangeRate: 0,
    highExchangeRate: 0,
    lowExchangeRate: 0,
    exchangeRate: 0,
    serviceFee: 0,
    serviceFeePercentage: 0,
    minAmount: 0,
    vcServiceFeePercentage: 0,
    vcGasFee: 0,
    digits: 0,
    priceDigits: 0,
  }

  private get isEdit() {
    return !!this.currencyId;
  }

  private get title() {
    return this.isEdit ? '修改' : '新增';
  }

  private rules = {
    currencyId: [this.requiredRule('虛擬貨幣')],
    costExchangeRate: [this.requiredRule('匯率成本')],
    highExchangeRate: [this.requiredRule('最高匯率')],
    lowExchangeRate: [this.requiredRule('最低匯率')],
    exchangeRate: [this.requiredRule('匯率')],
    minAmount: [this.requiredRule('最少申購數量')],
    vcServiceFeePercentage: [this.requiredRule('手續費百分比(單位:虛擬貨幣)')],
    vcGasFee: [this.requiredRule('提領手續費(單位:虛擬貨幣)')],
    digits: [this.requiredRule('最小下單位數(小數點後幾位數)')],
    priceDigits: [this.requiredRule('價格單位數(小數點後幾位)')],
  }

  private requiredRule(column: string) {
    return (v: any) => !Util.isNullOrEmpty(v) || `${column} 為必填`;
  }

  private async cancel() {
    await this.$router.back();
  }

  private async submit() {
    const form = this.$refs.form as any as { validate: () => boolean };
    if (form.validate()) {
      const data = this.isEdit
        ? { ...this.form, currencyId: this.currencyId } : { ...this.form };
      const { status, message } = this.isEdit
        ? await exchanger.editCurrency(data)
        : await exchanger.addCurrency(data);
      if (status === 1) {
        await Swal.fire({ icon: 'success', title: `${this.title}成功` });
        this.$router.back();
      } else {
        await Swal.fire({ icon: 'warning', title: message });
      }
    }
  }

  private async bindCurrencyOption() {
    const { data } = await exchanger.currencyOption(this.exchangerId, 2);
    this.currencyOption = data;
  }

  private async mounted() {
    await this.bindCurrencyOption();
    if (this.isEdit) {
      const { data } = await exchanger.currency(this.exchangerId, this.currencyId);
      this.form = data;
    }
  }
}
